import classNames from "classnames/bind";

import styles from "./Stock.module.scss";

const cx = classNames.bind(styles);

const addCommasNumber = (number: number) => number.toLocaleString("en-GB");

type Props = {
    stockNumber: number;
};

export const Stock = ({ stockNumber }: Props) => (
    <div className={cx("stock")}>
        <span>{addCommasNumber(stockNumber)}</span>
        <span>in stock</span>
    </div>
);
